(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class TtHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('.tt-header');
      this.menu = this.querySelector('[data-mobile-menu]');
      this.openBtn = this.querySelector('[data-open-menu]');
      this.closeBtn = this.querySelector('[data-close-menu]');

      this.cartDrawer = this.querySelector('[data-cart-drawer]');
      this.cartBackdrop = this.querySelector('[data-cart-backdrop]');
      this.cartOpenBtn = this.querySelector('[data-open-cart]');
      this.cartCloseBtn = this.querySelector('[data-close-cart]');
      this.cartBody = this.querySelector('[data-cart-body]');
      this.cartFoot = this.querySelector('[data-cart-foot]');
      this.cartSubtotal = this.querySelector('[data-cart-subtotal]');
      this.cartBadge = this.querySelector('[data-cart-count]');

      this.onScroll = this.onScroll.bind(this);
      this.openMenu = this.openMenu.bind(this);
      this.closeMenu = this.closeMenu.bind(this);
      this.openCart = this.openCart.bind(this);
      this.closeCart = this.closeCart.bind(this);
      this.onKey = this.onKey.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('keydown', this.onKey);
      this.openBtn && this.openBtn.addEventListener('click', this.openMenu);
      this.closeBtn && this.closeBtn.addEventListener('click', this.closeMenu);
      this.querySelectorAll('[data-mobile-menu] a').forEach(a => a.addEventListener('click', this.closeMenu));

      this.cartOpenBtn && this.cartOpenBtn.addEventListener('click', this.openCart);
      this.cartCloseBtn && this.cartCloseBtn.addEventListener('click', this.closeCart);
      this.cartBackdrop && this.cartBackdrop.addEventListener('click', this.closeCart);

      this.bindCartLines();
      this.bindAjaxAdds();
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKey);
    }
    onScroll() {
      if (!this.header) return;
      this.header.classList.toggle('is-scrolled', window.scrollY > 40);
    }
    onKey(e) {
      if (e.key === 'Escape') { this.closeMenu(); this.closeCart(); }
    }
    openMenu() {
      this.menu && this.menu.classList.add('is-open');
      document.body.classList.add('tt-menu-open');
    }
    closeMenu() {
      this.menu && this.menu.classList.remove('is-open');
      document.body.classList.remove('tt-menu-open');
    }
    openCart() {
      if (!this.cartDrawer) return;
      this.cartDrawer.classList.add('is-open');
      this.cartDrawer.setAttribute('aria-hidden', 'false');
      this.cartBackdrop && this.cartBackdrop.classList.add('is-open');
      document.body.classList.add('tt-cart-open');
      this.refreshCart();
    }
    closeCart() {
      if (!this.cartDrawer) return;
      this.cartDrawer.classList.remove('is-open');
      this.cartDrawer.setAttribute('aria-hidden', 'true');
      this.cartBackdrop && this.cartBackdrop.classList.remove('is-open');
      document.body.classList.remove('tt-cart-open');
    }
    bindCartLines() {
      const root = this.cartBody;
      if (!root) return;
      root.querySelectorAll('[data-cart-line]').forEach(line => {
        const key = line.dataset.lineKey;
        const valueEl = line.querySelector('[data-qty-value]');
        const get = () => parseInt(valueEl && valueEl.textContent || '0', 10);
        const dec = line.querySelector('[data-qty-decrement]');
        const inc = line.querySelector('[data-qty-increment]');
        const rm = line.querySelector('[data-remove]');
        dec && dec.addEventListener('click', () => this.updateLine(key, Math.max(0, get() - 1)));
        inc && inc.addEventListener('click', () => this.updateLine(key, get() + 1));
        rm && rm.addEventListener('click', () => this.updateLine(key, 0));
      });
    }
    bindAjaxAdds() {
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        if (form.dataset.ttSkipAjax) return;
        e.preventDefault();
        const fd = new FormData(form);
        fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(r => r.json())
          .then(() => this.refreshCart(true))
          .catch(() => { form.dataset.ttSkipAjax = '1'; form.submit(); });
      });
    }
    updateLine(key, quantity) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(r => r.json())
      .then(cart => this.renderCart(cart));
    }
    refreshCart(openAfter) {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(cart => {
          this.renderCart(cart);
          if (openAfter) this.openCart();
        });
    }
    renderCart(cart) {
      if (this.cartBadge) {
        this.cartBadge.textContent = cart.item_count;
        this.cartBadge.toggleAttribute('hidden', cart.item_count === 0);
      }
      if (this.cartSubtotal) this.cartSubtotal.textContent = this.formatMoney(cart.total_price);
      if (this.cartFoot) this.cartFoot.toggleAttribute('hidden', cart.item_count === 0);
      if (this.cartBody) {
        const sectionId = this.dataset.sectionId;
        if (sectionId) {
          const url = window.Shopify.routes.root + '?sections=' + sectionId;
          fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(r => r.json())
            .then(data => {
              const html = data[sectionId];
              if (!html) return this.renderCartFallback(cart);
              const tmp = document.createElement('div');
              tmp.innerHTML = html;
              const newBody = tmp.querySelector('[data-cart-body]');
              if (newBody) { this.cartBody.innerHTML = newBody.innerHTML; this.bindCartLines(); }
            })
            .catch(() => this.renderCartFallback(cart));
        } else {
          this.renderCartFallback(cart);
        }
      }
    }
    renderCartFallback(cart) {
      if (cart.item_count === 0) {
        this.cartBody.innerHTML = '<div class="tt-cart-empty"><div class="tt-cart-empty__title">Your Cart Is Empty</div><p class="tt-cart-empty__text">Begin with The Phoenix capsule. Limited runs only.</p></div>';
        return;
      }
      this.cartBody.querySelectorAll('[data-cart-line]').forEach(line => {
        const key = line.dataset.lineKey;
        const item = cart.items.find(i => i.key === key);
        if (!item) { line.remove(); return; }
        const v = line.querySelector('[data-qty-value]');
        if (v) v.textContent = item.quantity;
        const tot = line.querySelector('.tt-cart-line__total');
        if (tot) tot.textContent = this.formatMoney(item.final_line_price);
      });
    }
    formatMoney(cents) {
      const n = cents / 100;
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(n); }
      catch (e) { return '$' + n.toFixed(2); }
    }
  }
  if (!customElements.get('tt-header')) customElements.define('tt-header', TtHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-cinematic-slider"] && !Shopify.designMode) return;
  try {
    
  class TtCinematicSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.tt-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.tt-slider__dot'));
      this.counter = this.querySelector('[data-counter-current]');
      this.current = 0;
      this.interval = parseInt(this.dataset.interval || '6000', 10);
      this.timer = null;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.index || '0', 10);
          this.go(idx);
          this.restart();
        });
      });

      // Prev / next arrow buttons
      this.querySelector('[data-slider-prev]')?.addEventListener('click', () => {
        this.go(this.current - 1);
        this.restart();
      });
      this.querySelector('[data-slider-next]')?.addEventListener('click', () => {
        this.go(this.current + 1);
        this.restart();
      });

      // Arrow-key navigation (left/right wrap; home/end jump)
      this.addEventListener('keydown', (e) => {
        if (this.slides.length < 2) return;
        let next = null;
        if (e.key === 'ArrowRight') next = this.current + 1;
        else if (e.key === 'ArrowLeft') next = this.current - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = this.slides.length - 1;
        if (next === null) return;
        e.preventDefault();
        this.go(next);
        this.restart();
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());

      // Defer start until visible
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              this.start();
            } else {
              this.stop();
            }
          });
        }, { threshold: 0.2 });
        io.observe(this);
      } else {
        this.start();
      }
    }
    disconnectedCallback() { this.stop(); }
    start() {
      if (this.slides.length < 2 || this.reduced || this.timer) return;
      this.timer = setInterval(() => this.go(this.current + 1), this.interval);
    }
    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
    restart() { this.stop(); this.start(); }
    go(idx) {
      const n = this.slides.length;
      const next = ((idx % n) + n) % n;
      if (next === this.current) return;
      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.dots[this.current]?.classList.remove('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'false');
      this.slides[next].classList.add('is-active');
      this.slides[next].setAttribute('aria-hidden', 'false');
      this.dots[next]?.classList.add('is-active');
      this.dots[next]?.setAttribute('aria-selected', 'true');
      this.current = next;
      if (this.counter) {
        this.counter.textContent = String(next + 1).padStart(2, '0');
      }
    }
  }
  if (!customElements.get('tt-cinematic-slider')) {
    customElements.define('tt-cinematic-slider', TtCinematicSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-contact"] && !Shopify.designMode) return;
  try {
    
  /* On contact-form submit, fire a parallel customer-create request so
     each submission is also logged as a tagged Customer in Shopify admin.
     Uses navigator.sendBeacon() so the request survives the page unload
     after the main form posts. Never blocks the visible submit. */
  (function () {
    var form = document.querySelector('form.tt-contact-form');
    if (!form || form.__ttContactBound) return;
    form.__ttContactBound = true;

    form.addEventListener('submit', function () {
      try {
        var data = new FormData(form);
        var email = (data.get('contact[email]') || '').trim();
        if (!email) return;

        var fullName = (data.get('contact[name]') || '').trim();
        var nameParts = fullName.split(/\s+/);
        var firstName = nameParts[0] || '';
        var lastName = nameParts.slice(1).join(' ') || '';
        var subject = (data.get('contact[subject]') || 'general').toLowerCase();

        var payload = new FormData();
        payload.append('form_type', 'customer');
        payload.append('utf8', '✓');
        payload.append('contact[email]', email);
        if (firstName) payload.append('contact[first_name]', firstName);
        if (lastName)  payload.append('contact[last_name]',  lastName);
        payload.append('contact[accepts_marketing]', 'false');
        payload.append('contact[tags]', 'contact-form, source:website, subject:' + subject);

        if (navigator.sendBeacon) {
          navigator.sendBeacon('/contact', payload);
        } else {
          /* Fallback: fire fetch with keepalive so it survives unload */
          fetch('/contact', { method: 'POST', body: payload, credentials: 'same-origin', keepalive: true }).catch(function(){});
        }
      } catch (e) { /* never block submit */ }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__ttProductCarouselInit) return;
    window.__ttProductCarouselInit = true;

    function init(root) {
      if (root.dataset.carouselReady === '1') return;
      var track = root.querySelector('[data-carousel-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (!track) return;

      function step(direction) {
        var slide = track.querySelector('.tt-product-carousel__slide');
        if (!slide) return;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 32;
        var delta = (slide.getBoundingClientRect().width + gap) * direction;
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }

      function update() {
        if (!prev || !next) return;
        var hasOverflow = track.scrollWidth > track.clientWidth + 4;
        root.dataset.noOverflow = hasOverflow ? '0' : '1';
        if (!hasOverflow) {
          prev.disabled = true;
          next.disabled = true;
          return;
        }
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      if (prev) prev.addEventListener('click', function() { step(-1); });
      if (next) next.addEventListener('click', function() { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      root.dataset.carouselReady = '1';
    }

    function initAll() {
      document.querySelectorAll('[data-carousel]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-fight-list"] && !Shopify.designMode) return;
  try {
    
  class TtFightList extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.tt-fight-row__head').forEach(btn => {
        btn.addEventListener('click', () => {
          const row = btn.closest('.tt-fight-row');
          const isOpen = row.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen);
        });
      });
      this.querySelectorAll('.tt-chip').forEach(chip => {
        chip.addEventListener('click', () => {
          this.querySelectorAll('.tt-chip').forEach(c => c.classList.remove('is-active'));
          chip.classList.add('is-active');
          const filter = chip.dataset.filter;
          this.querySelectorAll('.tt-fight-row').forEach(row => {
            const r = row.dataset.result;
            let show = true;
            if (filter === 'wins') show = (r === 'W' || r === 'KO');
            else if (filter === 'losses') show = (r === 'L');
            else if (filter === 'kos') show = (r === 'KO');
            row.toggleAttribute('hidden', !show);
          });
        });
      });
    }
  }
  if (!customElements.get('tt-fight-list')) customElements.define('tt-fight-list', TtFightList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-fights-hero"] && !Shopify.designMode) return;
  try {
    
  class TtFightsHeroStats extends HTMLElement {
    connectedCallback() {
      this.values = Array.from(this.querySelectorAll('[data-stat-target]'));
      if (this.values.length === 0) return;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.started = false;

      // Reset to 0 before count begins
      if (!this.reduced) {
        this.values.forEach(v => { v.textContent = '0'; });
      } else {
        this.classList.add('is-animated');
        return;
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.started) {
              this.started = true;
              this.classList.add('is-animated');
              this.start();
              io.disconnect();
            }
          });
        }, { threshold: 0.35 });
        io.observe(this);
      } else {
        this.classList.add('is-animated');
        this.start();
      }
    }
    start() {
      this.values.forEach((el, i) => {
        const target = parseInt(el.dataset.statTarget || '0', 10);
        const delay = 180 * i; // staggered start per stat
        const duration = 1200 + (i * 80);
        setTimeout(() => this.countUp(el, target, duration), delay);
      });
    }
    countUp(el, target, duration) {
      if (target <= 0) { el.textContent = target; return; }
      const start = performance.now();
      const ease = (t) => 1 - Math.pow(1 - t, 3); // easeOutCubic
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const value = Math.round(target * ease(t));
        el.textContent = value;
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = target;
      };
      requestAnimationFrame(step);
    }
  }
  if (!customElements.get('tt-fights-hero-stats')) {
    customElements.define('tt-fights-hero-stats', TtFightsHeroStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-media-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var buttons = document.querySelectorAll('[data-yt-play]');
    buttons.forEach(function (btn) {
      if (btn.dataset.ttYtBound) return;
      btn.dataset.ttYtBound = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.tt-mf__media--video');
        if (!wrap) return;
        var id = wrap.getAttribute('data-yt-id');
        if (!id) return;
        var caption = wrap.querySelector('.tt-mf__media-caption');
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
        iframe.setAttribute('title', 'Highlights');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; web-share; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.className = 'tt-mf__media-iframe';
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
        if (caption) wrap.appendChild(caption);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-product"] && !Shopify.designMode) return;
  try {
    
  class TtProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.tt-product__form');
      this.priceEl = this.querySelector('[data-product-price]');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.variants = this.parseVariants();
      this.images = this.parseImages();
      this.currentImageIndex = 0;

      this.querySelectorAll('[data-qty-decrement]').forEach(b => b.addEventListener('click', () => this.changeQty(-1)));
      this.querySelectorAll('[data-qty-increment]').forEach(b => b.addEventListener('click', () => this.changeQty(1)));

      this.querySelectorAll('.tt-product__option-value').forEach(b => {
        b.addEventListener('click', () => {
          const idx = parseInt(b.dataset.optionIndex, 10);
          const val = b.dataset.optionValue;
          const group = b.closest('.tt-product__option-values');
          group.querySelectorAll('.tt-product__option-value').forEach(x => x.classList.remove('is-active'));
          b.classList.add('is-active');
          this.updateVariant();
        });
      });

      this.querySelectorAll('[data-thumb]').forEach(t => {
        t.addEventListener('click', () => {
          this.querySelectorAll('[data-thumb]').forEach(x => x.classList.remove('is-active'));
          t.classList.add('is-active');
          const main = this.querySelector('.tt-product__main-img');
          if (main && t.dataset.imageSrc) main.src = t.dataset.imageSrc;
          const idx = parseInt(t.dataset.imageIndex, 10);
          if (!Number.isNaN(idx)) this.currentImageIndex = idx;
          this.openLightbox(this.currentImageIndex || 0);
        });
      });

      this.setupLightbox();
    }
    parseVariants() {
      const el = this.querySelector('[data-variants]');
      if (!el) return [];
      try { return JSON.parse(el.textContent); } catch (e) { return []; }
    }
    parseImages() {
      const el = this.querySelector('[data-images]');
      if (!el) return [];
      try { return JSON.parse(el.textContent); } catch (e) { return []; }
    }

    setupLightbox() {
      this.lightbox = this.querySelector('[data-lightbox]');
      if (!this.lightbox || !this.images.length) return;
      this.lightboxStage = this.lightbox.querySelector('[data-lightbox-stage]');
      this.lightboxImg = this.lightbox.querySelector('[data-lightbox-img]');
      this.lightboxCounter = this.lightbox.querySelector('[data-lightbox-counter]');
      this.lightboxIndex = 0;

      const mainBtn = this.querySelector('[data-zoom-open]');
      if (mainBtn) mainBtn.addEventListener('click', () => this.openLightbox(this.currentImageIndex || 0));

      this.lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.closeLightbox());
      this.lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', (e) => { e.stopPropagation(); this.navLightbox(-1); });
      this.lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', (e) => { e.stopPropagation(); this.navLightbox(1); });

      // Click outside image closes; click on image toggles zoom
      this.lightboxStage.addEventListener('click', (e) => {
        if (e.target === this.lightboxImg) {
          this.toggleZoom(e);
        } else if (e.target === this.lightboxStage) {
          this.closeLightbox();
        }
      });

      // Magnifier pan while zoomed
      this.lightboxStage.addEventListener('mousemove', (e) => {
        if (this.lightboxStage.classList.contains('is-zoomed')) this.applyZoomTransform(e);
      });
      this.lightboxStage.addEventListener('mouseleave', () => {
        if (this.lightboxStage.classList.contains('is-zoomed')) this.resetZoom();
      });

      // Keyboard: ESC handled natively by <dialog>; arrows navigate
      this.lightbox.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this.navLightbox(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.navLightbox(1); }
      });

      // Native dialog close (ESC, close()) — restore scroll, sync hero to last-viewed image
      this.lightbox.addEventListener('close', () => {
        document.body.style.overflow = '';
        this.resetZoom();
        this.syncMainToIndex(this.lightboxIndex);
      });
    }

    openLightbox(index) {
      if (!this.lightbox || !this.images.length) return;
      this.showLightboxImage(index);
      this.lightbox.showModal();
      document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.close();
    }

    syncMainToIndex(index) {
      const img = this.images[index];
      if (!img) return;
      this.currentImageIndex = index;
      const main = this.querySelector('.tt-product__main-img');
      if (main) main.src = img.src;
      const thumbs = this.querySelectorAll('[data-thumb]');
      thumbs.forEach(t => t.classList.toggle('is-active', parseInt(t.dataset.imageIndex, 10) === index));
    }

    navLightbox(delta) {
      const n = this.images.length;
      if (!n) return;
      const next = (this.lightboxIndex + delta + n) % n;
      this.resetZoom();
      this.showLightboxImage(next);
    }

    showLightboxImage(index) {
      const img = this.images[index];
      if (!img || !this.lightboxImg) return;
      this.lightboxIndex = index;
      this.lightboxImg.src = img.src;
      this.lightboxImg.alt = img.alt || '';
      if (this.lightboxCounter) this.lightboxCounter.textContent = (index + 1) + ' / ' + this.images.length;
    }

    toggleZoom(e) {
      if (!this.lightboxStage || !this.lightboxImg) return;
      const isZoomed = this.lightboxStage.classList.toggle('is-zoomed');
      if (isZoomed) {
        this.applyZoomTransform(e);
      } else {
        this.lightboxImg.style.transform = '';
      }
    }

    resetZoom() {
      if (!this.lightboxStage || !this.lightboxImg) return;
      this.lightboxStage.classList.remove('is-zoomed');
      this.lightboxImg.style.transform = '';
    }

    applyZoomTransform(e) {
      const stage = this.lightboxStage.getBoundingClientRect();
      const dx = e.clientX - (stage.left + stage.width / 2);
      const dy = e.clientY - (stage.top + stage.height / 2);
      const scale = 2.4;
      const tx = -(scale - 1) * dx;
      const ty = -(scale - 1) * dy;
      this.lightboxImg.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
    }
    changeQty(delta) {
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;
      const next = Math.max(1, parseInt(input.value || '1', 10) + delta);
      input.value = next;
    }
    selectedOptions() {
      const groups = this.querySelectorAll('.tt-product__option-values');
      const arr = [];
      groups.forEach((g, i) => {
        const active = g.querySelector('.tt-product__option-value.is-active');
        arr[i] = active ? active.dataset.optionValue : null;
      });
      return arr;
    }
    updateVariant() {
      const sel = this.selectedOptions();
      const match = this.variants.find(v => v.options.every((o, i) => o === sel[i]));
      if (!match) return;
      if (this.variantIdInput) this.variantIdInput.value = match.id;
      if (this.priceEl) {
        this.priceEl.textContent = this.formatMoney(match.price);
      }
      const addBtn = this.querySelector('.tt-product__add');
      if (addBtn) {
        addBtn.toggleAttribute('disabled', !match.available);
        addBtn.textContent = match.available ? 'Add To Cart' : 'Sold Out';
      }
    }
    formatMoney(cents) {
      const n = cents / 100;
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD' }).format(n); }
      catch (e) { return '$' + n.toFixed(2); }
    }
  }
  if (!customElements.get('tt-product')) customElements.define('tt-product', TtProduct);

  } catch(e) { console.error(e); }
})();
})();
